import { render, staticRenderFns } from "./productPage.vue?vue&type=template&id=24e9e500"
import script from "./productPage.vue?vue&type=script&lang=ts"
export * from "./productPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports